const MENTIONS_CLASSNAME = "withEHQMentions";
const OLD_MENTIONS_CLASSNAME = "mention";

export { MENTIONS_CLASSNAME, OLD_MENTIONS_CLASSNAME };
